let Shop = function (memberId, name, urlName) {
    this.memberId = memberId || 0;
    this.name = name || '';
    this.urlName = urlName || '';
};

export default Shop;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/models/shop.js